import type { AppLocale } from './localeRouting';

function localeFromBrowser(): AppLocale {
  const langs = [...(navigator.languages ?? []), navigator.language].filter(Boolean);
  for (const lang of langs) {
    const lower = lang.toLowerCase();
    if (lower.startsWith('ko')) return 'ko';
    if (lower.startsWith('ja')) return 'ja';
  }
  return 'en';
}

function localeFromCountry(countryCode: string | undefined | null): AppLocale | null {
  if (!countryCode) return null;
  const code = countryCode.toUpperCase();
  if (code === 'KR') return 'ko';
  if (code === 'JP') return 'ja';
  return 'en';
}

/**
 * IP 국가 기준 locale 감지. 실패 시 브라우저 언어로 폴백.
 * 타임아웃/네트워크 오류에도 반드시 locale을 반환한다.
 */
export async function detectLocaleFromGeo(timeoutMs = 2500): Promise<AppLocale> {
  const controller = new AbortController();
  const timer = window.setTimeout(() => controller.abort(), timeoutMs);

  try {
    const res = await fetch('https://ipapi.co/json/', {
      signal: controller.signal,
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) return localeFromBrowser();
    const data = (await res.json()) as { country_code?: string };
    return localeFromCountry(data.country_code) ?? localeFromBrowser();
  } catch {
    return localeFromBrowser();
  } finally {
    window.clearTimeout(timer);
  }
}
